import React from 'react';
import { CtaButton } from './CtaButton';
import { stats } from '../data/content';
const questions = ['Which composite should I use?', 'What opacity do I need?', 'How should I approach the layering?', 'What should I analyze before I start?'];
export function ProblemSection() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8 md:py-20" data-id="element-214" data-mp="2vpzekzzlclkk">
      <div className="mx-auto max-w-3xl" data-id="element-215" data-mp="39hw02l6r7x7z">
        <h2 className="font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-216" data-mp="39gupsixkberb">
          How much time do you spend figuring out how to approach an anterior case?
        </h2>

        <p className="mt-6 text-[16px] leading-relaxed text-clay sm:text-lg" data-id="element-217" data-mp="3jgbp8im80weu">
          You already know the clinical principles. But when you’re actually facing the case,
          you still have to ask:
        </p>

        <ul className="mt-6 space-y-3" data-id="element-218" data-mp="1p2u2gxtn43kv">
          {questions.map(question => <li key={question} className="border-l-2 border-gold bg-cream px-4 py-3 font-display text-[17px] italic text-ink sm:text-xl" data-id="element-219" data-mp="1k3zlm1f8gp3e">
              “{question}”
            </li>)}
        </ul>

        <p className="mt-8 text-[16px] leading-relaxed text-ink sm:text-lg" data-id="element-220" data-mp="o9u2h80051b9">
          <strong className="font-bold" data-id="element-221" data-mp="scichj0gce9t">Resin Architect™</strong> was created to turn those
          questions into a clear visual decision process.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-222" data-mp="122jq1gv6ieah">
        {stats.map(stat => <div key={stat.label} className="flex h-full flex-col rounded-2xl border border-ink/10 bg-cream px-4 py-5 text-center" data-id="element-223" data-mp="170uzvrlh4osp">
            <p className="font-display text-3xl font-bold leading-none text-gold-deep sm:text-4xl" data-id="element-224" data-mp="1g2co5x91bwsh">
              {stat.value}
            </p>
            <p className="mt-auto pt-3 text-[11px] font-semibold uppercase leading-snug tracking-[0.08em] text-clay" data-id="element-225" data-mp="3dv8kdybxom50">
              {stat.label}
            </p>
          </div>)}
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-226" data-mp="p2d2u3d7dxc6">
        <CtaButton label="I want a structured system" data-id="element-227" data-mp="k1z5pgd547sx" />
      </div>
    </section>;
}